/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSquareOnlineSiteMapping} from '../api'

 export const useQueryGetSquareOnlineSiteMapping = createReactQueryHook('getSquareOnlineSiteMapping', getSquareOnlineSiteMapping)
